/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.PICKLIST_MULTISELECT = function () {

    this.resourceKey = 'Survey.Sidebar.SelectMany';
    this.jsonType = 'PICKLIST_MULTISELECT';
    this.textAreaId = 'SelectManyAnswer';
    this.bodyClass = "selectManyBody";

    Greenmile.Survey.Sidebar.GenericMultiAnswers.apply(this, arguments);

    this.validate = function (defaultValue, answerOptions) {
        var errors         = [],
            defaultAnswers = defaultValue ? defaultValue.split(';') : [],
            options        = answerOptions.map(function (value) {
                return value.value;
            }),
            value          = defaultAnswers.filter(function (option) {
                return options.indexOf(option) === -1;
            });

        if (defaultValue && value.length) {
            errors.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.defaultValueIsNotOneOption'));
        }

        return errors;
    };

    this.addQuestionContent = function (questionContent, input) {

        let checkbox               = null,
            checkboxEl             = null,
            answers                = input.answerOptions,
            answerContent          = questionContent.querySelector('.answerContent'),
            newQuestionDescription = questionContent.querySelector('.newQuestionDescription'),
            questionText           = input.questionText,
            defaultValue           = input.questionData ? input.questionData.defaultAnswer : input.defaultAnswer,
            defaultAnswers         = defaultValue ? defaultValue.split(';') : [];

        answerContent.innerHTML = '';

        newQuestionDescription.title = questionText;
        newQuestionDescription.innerHTML = questionText;

        questionContent.setAttribute('questionType', input.questionType);

        if(answers) {

            for (var i = 0; i < answers.length; i++) {

                var answer = answers[i],
                  edit = Greenmile.Survey.Widgets.editLink(answer),
                  remove = Greenmile.Survey.Widgets.removeLink(answer),
                  drag = document.createElement('div');

                checkbox = new Monet.UI.Fields.Render({
                    type: 'CHECKBOX',
                    name: questionContent.getAttribute('question_id'),
                    label: answers[i].value
                }, 'Survey').render();

                if (Greenmile.Survey.Builder.releasedDate) {

                    edit.style.display = 'none';
                    remove.style.display = 'none';

                }

                checkbox.input.checked = defaultAnswers.indexOf(answers[i].value) !== -1;
                checkboxEl = checkbox.rootEl;
                checkboxEl.id = answers[i].id;

                var label = checkboxEl.getElementsByTagName('label')[0];
                label.title = answer.value;

                var checkboxInput = checkboxEl.querySelector('input[type="checkbox"]');
                drag.className = 'dragQuestionDomain';
                checkboxEl.insertBefore(drag, checkboxInput);

                checkboxEl.appendChild(edit);
                checkboxEl.appendChild(remove);
                answerContent.appendChild(checkboxEl);
            }
        }
        var questionID = questionContent.getAttribute('question_id');
        $('div[question_id="' + questionID + '"] .answerContent').sortable({ axis: "y" });

    };

    this.serializeInput = function (questionData) {
        var maxLength      = 255,
            defaultValue   = (this.fieldDefaultAnswer ? this.fieldDefaultAnswer.getValue() : ''),
            defaultAnswers = defaultValue ? defaultValue.split(';') : [];

        var questionElement = document.querySelector(this.questionDescriptorSelector),
            answerElement   = document.querySelector('#' + this.textAreaId);

        var questionText  = questionElement.value,
            answerText    = answerElement ? answerElement.value : '',
            options       = answerText.split('\n'),
            answerOptions = options.map(function (option) {
                return { description: option, value: option };
            });

        var hiddenType   = document.getElementsByName('questionType')[0],
            questionType = hiddenType.value;

        answerOptions = Greenmile.Survey.Sidebar.answerCropExceedLength(answerOptions, maxLength);

        for (var z = 0; z < answerOptions.length; z++) {

            var option = answerOptions[z];

            if (!option) {
                answerOptions.splice(z, 1);
            }
        }

        answerOptions = answerOptions.map((answer) => {
            return { value: answer.value.trim() };
        });

        defaultAnswers = defaultAnswers.map((answer) => {
            return { value: answer.trim() };
        });

        defaultAnswers = Greenmile.Survey.Sidebar.answerCropExceedLength(defaultAnswers, maxLength);

        defaultValue = defaultAnswers.map((answer) => {
            return answer.value;
        }).join(';');

        return {
            questionType: questionType,
            questionText: questionText,
            answerOptions: answerOptions,
            defaultAnswer: defaultValue,
            errors: this.validate(defaultValue, answerOptions)
        };

    };

    this.serializeContent = function (question) {
        var baseSelector   = '.newQuestionContent[question_id="' + question.id + '"] > .answerContent input[type="checkbox"]',
            checks         = question.el.parentNode.querySelectorAll(baseSelector),
            answer,
            action         = Greenmile.Survey.Builder.action,
            checksToReturn = [],
            parentNode,
            i,
            check;

        for (i = 0; i < checks.length; i++) {

            parentNode = checks[i].parentNode;
            answer = Greenmile.Survey.Data.findQuestionDomain(question, parentNode.id);
            check = {};

            if (answer.isNew !== true && action === 'update') {

                check.id = answer.id;

            }

            check.value = answer.value;
            check.surveyQuestionDomainOrder = i;
            checksToReturn.push(check);

        }

        return checksToReturn;
    };

};
